import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content } from 'rsuite';
import { map, isEmpty } from 'lodash/fp';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { viewAccess } from '../../../../helpers/permission';
import {
  fetchPosTrackingMethods,
  fetchPosTrackingMethodLocations
} from '../../../../redux/Settings/sagas/routines';
import {
  getIsFetching as getIsFetchingTrackingMethods,
  getAll as getTrackingMethods
} from '../../../../redux/Settings/selectors/pos/trackingMethods';
import {
  getIsFetching as getIsFetchingLocations,
  getPosLocationsByTrackingMethods
} from '../../../../redux/Settings/selectors/pos/trackingMethodLocations';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/settings/pos/PageLayout';
import Breadcrumb from '../../../../components/Breadcrumb';
import TrackingMethodLocationList from '../../../../components/settings/pos/TrackingMethodLocationList';
import { settingsPosPath } from '../../../Paths';

export default () => {
  const dispatch = useDispatch();
  const isFetchingLocations = useSelector(getIsFetchingLocations);
  const isFetchingTrackingMethods = useSelector(getIsFetchingTrackingMethods);
  const isFetching = isFetchingLocations || isFetchingTrackingMethods;
  const trackingMethods = useSelector(getTrackingMethods);
  const locationsByTrackingMethod = useSelector(
    getPosLocationsByTrackingMethods
  );

  useEffect(() => {
    dispatch(fetchPosTrackingMethods());
  }, []);

  useEffect(
    () => {
      if (!isEmpty(trackingMethods)) {
        dispatch(
          fetchPosTrackingMethodLocations({ id: map('id', trackingMethods) })
        );
      }
    },
    [trackingMethods]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.POS)}
        fallback={<AccessDenied />}
      >
        <Breadcrumb
          items={[
            { label: 'POS Settings', path: settingsPosPath },
            { label: 'Tracking Method Locations' }
          ]}
        />
        <PageHeader title="Tracking Method Locations" />
        <Content style={{ marginTop: 0 }}>
          <TrackingMethodLocationList
            isFetching={isFetching}
            trackingMethods={trackingMethods}
            locationsByTrackingMethod={locationsByTrackingMethod}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
